<template>
    <div>
        <!-- 输入框 -->
        <a-input :type="type" style="margin-bottom: 20px" v-model:value="state.phone" @blur="inputEnterBlur"
            @pressEnter="inputEnterBlur" :placeholder="props.placeholder">
            <template #suffix>
                <a-tooltip :title="props.suffixTitle">
                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                </a-tooltip>
            </template>
            <!-- 输入框后缀提示 -->
        </a-input>
        <div>
            <!-- 价格列表 -->
            <div v-for="(item, index) in state.phoneList" :key="index" class="phone-item" style="margin-bottom: 20px">
                <a-badge-ribbon placement="start">
                    <template #text>{{ item.name }}</template>
                    <a-card size="small">
                        <template #title>
                            <a-row>
                                <a-col :span="7"> </a-col>
                                <a-col :span="10">
                                    <div>
                                        <a-form-item name="默认授权" class="phone-item-margin">
                                            <a-checkbox v-model:checked="item.default"
                                                style="font-size: 12px">授权用户默认授权价格</a-checkbox>
                                        </a-form-item>
                                    </div>
                                </a-col>
                                <a-col :span="7">
                                    <div>
                                        <a-form-item name="许可单独售价" class="phone-item-margin">
                                            <a-checkbox v-model:checked="item.xukeddprice"
                                                style="font-size: 12px">许可单独售价</a-checkbox>
                                        </a-form-item>
                                    </div>
                                </a-col>
                                <a-col :span="10">
                                    <div>
                                        <a-form-item name="税务身份单独售价" class="phone-item-margin">
                                            <a-checkbox v-model:checked="item.ybrddprice"
                                                style="font-size: 12px">税务一般人单独售价</a-checkbox>
                                        </a-form-item>
                                    </div>
                                </a-col>
                                <a-col :span="2">
                                    <!-- 删除按钮 -->
                                    <DeleteOutlined style="cursor: pointer; margin-top: 9px"
                                        @click="deleteClick(index)" />
                                </a-col> </a-row></template>
                        <a-row>
                            <a-col :span="24"><a-divider plain="true">代理商价格明细↓</a-divider></a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">包注册↓</a-col>
                            <a-col :span="6">裸地址↓</a-col>
                            <a-col :span="6">一次性↓</a-col>
                            <a-col :span="6">续费↓</a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.price1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格" v-model:value="item.price2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格" v-model:value="item.price3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格" v-model:value="item.price4"></a-input></a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.recommend1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.recommend2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.recommend3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.recommend4"></a-input></a-col>
                        </a-row>
                        <a-row v-if="item.xukeddprice">
                            <a-col :span="24"><a-divider plain="true">许可单独价格明细↓</a-divider></a-col>
                        </a-row>
                        <a-row v-if="item.xukeddprice">
                            <a-col :span="6">包注册↓</a-col>
                            <a-col :span="6">裸地址↓</a-col>
                            <a-col :span="6">一次性↓</a-col>
                            <a-col :span="6">续费↓</a-col>
                        </a-row>
                        <a-row v-if="item.xukeddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.xk_price1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.xk_price2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.xk_price3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.xk_price4"></a-input></a-col>
                        </a-row>
                        <a-row v-if="item.xukeddprice">
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                        </a-row>
                        <a-row v-if="item.xukeddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.xk_recommend1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.xk_recommend2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.xk_recommend3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.xk_recommend4"></a-input></a-col>
                        </a-row>


                        <a-row v-if="item.ybrddprice">
                            <a-col :span="24"><a-divider plain="true">税务一般人单独价格明细↓</a-divider></a-col>
                        </a-row>
                        <a-row v-if="item.ybrddprice">
                            <a-col :span="6">包注册↓</a-col>
                            <a-col :span="6">裸地址↓</a-col>
                            <a-col :span="6">一次性↓</a-col>
                            <a-col :span="6">续费↓</a-col>
                        </a-row>
                        <a-row v-if="item.ybrddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.ybr_price1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.ybr_price2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.ybr_price3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.ybr_price4"></a-input></a-col>
                        </a-row>
                        <a-row v-if="item.ybrddprice">
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                            <a-col :span="6">推荐售价↓</a-col>
                        </a-row>
                        <a-row v-if="item.ybrddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.ybr_recommend1"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.ybr_recommend2"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.ybr_recommend3"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.ybr_recommend4"></a-input></a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="24"><a-divider style="cursor: pointer" plain="true"
                                    @click="changShow5678()">服务商给地址方↓</a-divider></a-col>
                        </a-row>
                        <a-row v-show="state.show5678">
                            <a-col :span="6">包注册↓</a-col>
                            <a-col :span="6">裸地址↓</a-col>
                            <a-col :span="6">一次性↓</a-col>
                            <a-col :span="6">续费↓</a-col>
                        </a-row>
                        <a-row v-show="state.show5678">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.price5"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格" v-model:value="item.price6"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格" v-model:value="item.price7"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格" v-model:value="item.price8"></a-input></a-col>
                        </a-row>
                        <a-row v-show="state.show5678 && item.xukeddprice">
                            <a-col :span="6">许可包注册↓</a-col>
                            <a-col :span="6">许可裸地址↓</a-col>
                            <a-col :span="6">许可一次性↓</a-col>
                            <a-col :span="6">许可续费↓</a-col>
                        </a-row>
                        <a-row v-show="state.show5678 && item.xukeddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.xk_price5"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.xk_price6"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.xk_price7"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.xk_price8"></a-input></a-col>
                        </a-row>
                        <a-row v-show="state.show5678 && item.ybrddprice">
                            <a-col :span="6">一般人包注册↓</a-col>
                            <a-col :span="6">一般人裸地址↓</a-col>
                            <a-col :span="6">一般人一次性↓</a-col>
                            <a-col :span="6">一般人续费↓</a-col>
                        </a-row>
                        <a-row v-show="state.show5678 && item.ybrddprice">
                            <a-col :span="6">
                                <a-input placeholder="包注册价格" v-model:value="item.ybr_price5"></a-input>
                            </a-col>
                            <a-col :span="6"><a-input placeholder="裸地址价格"
                                    v-model:value="item.ybr_price6"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="一次性价格"
                                    v-model:value="item.ybr_price7"></a-input></a-col>
                            <a-col :span="6"><a-input placeholder="续费价格"
                                    v-model:value="item.ybr_price8"></a-input></a-col>
                        </a-row>
                    </a-card>
                </a-badge-ribbon>
            </div>
        </div>
        <a-descriptions title="以上价格所属平台信息↑↑↑" bordered size="small" :column="2">
            <a-descriptions-item label="平台全称">{{ formState?.name }}</a-descriptions-item>
            <a-descriptions-item label="平台简称">{{ formState?.platform_abbreviation }}</a-descriptions-item>
            <a-descriptions-item label="平台地址">{{ formState?.company_detailed_address }}</a-descriptions-item>
        </a-descriptions>
    </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from 'vue'
import { message } from 'ant-design-vue'
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: Array
    },
    formState: {
        type: Object
    },
    placeholder: {
        type: String
    },
    suffixTitle: {
        type: String
    },
    inputType: {
        type: String
    },
    type: {
        type: String,
        default: 'text'
    }
})
interface state {
    phone: string
    phoneList: {
        name: string
        default: number | 0
        xukeddprice: number | 0
        ybrddprice: number | 0
        price1: number | undefined
        price2: number | undefined
        price3: number | undefined
        price4: number | undefined
        price5: number | undefined
        price6: number | undefined
        price7: number | undefined
        price8: number | undefined
        recommend1: number | undefined
        recommend2: number | undefined
        recommend3: number | undefined
        recommend4: number | undefined
        xk_price1: number | undefined
        xk_price2: number | undefined
        xk_price3: number | undefined
        xk_price4: number | undefined
        xk_price5: number | undefined
        xk_price6: number | undefined
        xk_price7: number | undefined
        xk_price8: number | undefined
        xk_recommend1: number | undefined
        xk_recommend2: number | undefined
        xk_recommend3: number | undefined
        xk_recommend4: number | undefined
        ybr_price1: number | undefined
        ybr_price2: number | undefined
        ybr_price3: number | undefined
        ybr_price4: number | undefined
        ybr_price5: number | undefined
        ybr_price6: number | undefined
        ybr_price7: number | undefined
        ybr_price8: number | undefined
        ybr_recommend1: number | undefined
        ybr_recommend2: number | undefined
        ybr_recommend3: number | undefined
        ybr_recommend4: number | undefined
    }[]
    show5678: boolean
}
const state = reactive<state>({
    phone: '',
    phoneList: [],
    show5678: false
})
watch(
    () => props.value,
    (val) => {
        if (val && val.length > 0) {
            state.phoneList = val as any
        }
    },
    {
        deep: true,
        immediate: true
    }
)

// 添加价格
const addPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber && phoneNumber.length > 0) {
        if (!state.phoneList.some((item: any) => item.name == phoneNumber)) {
            let line = {
                name: phoneNumber,
                default: 0,  // 修改为number类型
                xukeddprice: 0,  // 添加所有必需的属性
                ybrddprice: 0,
                price1: undefined,
                price2: undefined,
                price3: undefined,
                price4: undefined,
                price5: undefined,
                price6: undefined,
                price7: undefined,
                price8: undefined,
                recommend1: undefined,
                recommend2: undefined,
                recommend3: undefined,
                recommend4: undefined,
                xk_price1: undefined,
                xk_price2: undefined,
                xk_price3: undefined,
                xk_price4: undefined,
                xk_price5: undefined,
                xk_price6: undefined,
                xk_price7: undefined,
                xk_price8: undefined,
                xk_recommend1: undefined,
                xk_recommend2: undefined,
                xk_recommend3: undefined,
                xk_recommend4: undefined,
                ybr_price1: undefined,
                ybr_price2: undefined,
                ybr_price3: undefined,
                ybr_price4: undefined,
                ybr_price5: undefined,
                ybr_price6: undefined,
                ybr_price7: undefined,
                ybr_price8: undefined,
                ybr_recommend1: undefined,
                ybr_recommend2: undefined,
                ybr_recommend3: undefined,
                ybr_recommend4: undefined
            }
            state.phoneList.push(line)
        }
        state.phone = ''
        emit('update:value', state.phoneList)
        emit('change', state.phoneList)
    }
}
//
const inputEnterBlur = (val) => {
    addPhoneNumber(val.target.value)
}
// 删除手机号码
const deleteClick = (index) => {
    state.phoneList.splice(index, 1)
    emit('update:value', state.phoneList)
}
const changShow5678 = () => {
    state.show5678 = !state.show5678
}
</script>

<style lang="less" scoped>
.phone-item {
    display: 100%;
    align-items: center;
    justify-content: space-between;
}

.phone-item-margin {
    margin-bottom: 0px;
    padding-bottom: 0px;
}
</style>
